import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const GuestGuard = ({ children }) => {
    const account = useSelector((state) => state.account);

    const { isLoggedIn } = account;

    if (isLoggedIn) {
        return <Navigate to={'/'} />;
    }

    return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
